import { SchemaModel, StringType, NumberType, ArrayType, DateType, ObjectType, BooleanType } from 'schema-typed';
export default {
  Model: SchemaModel,
  Types: {
    StringType: StringType,
    NumberType: NumberType,
    ArrayType: ArrayType,
    DateType: DateType,
    ObjectType: ObjectType,
    BooleanType: BooleanType
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite/es/Schema/Schema.js
// module id = 2497
// module chunks = 33